export default __webpack_public_path__ + "static/oceania-705152447913b250534ff694dea71634.svg";